import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ProjectConversationMemberInvited } from 'api/notifications/meta';
import { Strong } from '../../basics';
import { Causer } from '../causer';

export const ProjectConversationMemberInvitedView: FC<{
  meta: ProjectConversationMemberInvited;
}> = ({ meta: { by, conversationName } }) => {
  return (
    <FormattedMessage
      id="notifications.messages.project_conversation.invited"
      values={{
        causer: <Causer user={by} />,
        name: <Strong>{conversationName}</Strong>,
      }}
    />
  );
};
